import { Card, Link, Tooltip, useCurrentMode } from '@lokalise/louis';

import { Icon, Icons } from '@app/components/Promo';
import asset from '@app/utils/asset';

import { PromoLink, Text, Title } from './styles';

interface TriggerPromoProps {
    projectId: string;
}

const TriggersPromo = ({ projectId }: TriggerPromoProps) => {
    const darkmode = useCurrentMode() === 'dark';

    return (
        <Card>
            <Title>App triggers</Title>
            <Text>Export files directly from your repository or other dev tools.</Text>
            <Icons>
                <Tooltip tooltip="Integration with Github">
                    <Link href={`/apps/${projectId}/#app:github`} target="_blank" rel="noreferrer">
                        <Icon
                            alt="Integration with Github"
                            src={asset(`/img/integrations/github${darkmode ? '_darkmode' : ''}.svg`)}
                        />
                    </Link>
                </Tooltip>
                <Tooltip tooltip="Integration with Gitlab">
                    <Link href={`/apps/${projectId}/#app:gitlab`} target="_blank" rel="noreferrer">
                        <Icon alt="Integration with Gitlab" src={asset('/img/integrations/gitlab.svg')} />
                    </Link>
                </Tooltip>
                <Tooltip tooltip="Integration with Bitbucket">
                    <Link href={`/apps/${projectId}/#app:bitbucket`} target="_blank" rel="noreferrer">
                        <Icon alt="Integration with Bitbucket" src={asset('/img/integrations/bitbucket.svg')} />
                    </Link>
                </Tooltip>
                <Tooltip tooltip="Integration with API">
                    <Link href="https://docs.lokalise.com/api-and-cli/lokalise-api" target="_blank" rel="noreferrer">
                        <Icon alt="Integration with API" src={asset('/img/integrations/api.png')} />
                    </Link>
                </Tooltip>
                <Tooltip tooltip="Integration with Amazon S3">
                    <Link href={`/apps/${projectId}/#app:amazons3`} target="_blank" rel="noreferrer">
                        <Icon alt="Integration with Amazon S3" src={asset('/img/integrations/s3.png')} />
                    </Link>
                </Tooltip>
            </Icons>
            <PromoLink>
                <Link href={`/apps/${projectId}/`} target="_blank" rel="noreferrer">
                    See app integrations
                </Link>
            </PromoLink>
        </Card>
    );
};

export default TriggersPromo;
